<template>
  <div class="comments-editor">
    <template v-if="status === 'view'">
      <div v-if="text">
        <a-popover
          v-model:visible="commentsViewPopoverVisible"
          placement="bottom"
        >
          <template #content>
            <div class="comments-view-popover">
              <div class="comments-view-text">{{ text }}</div>
            </div>
          </template>
          <svg-icon icon-class="search-view"></svg-icon>
          <a-button type="link">{{ $t('user.View Comments') }}</a-button>
        </a-popover>
      </div>
      <div v-else style="color: #333">{{ $t('user.No Comments') }}</div>
    </template>
    <template v-else>
      <a-popover
        v-if="text"
        v-model:visible="commentsViewPopoverVisible"
        placement="bottom"
      >
        <template #content>
          <div class="comments-view-popover">
            <close-outlined
              class="btn-popover-close"
              @click="
                () => {
                  this.commentsViewPopoverVisible = false
                }
              "
            />
            <div class="comments-text">{{ text }}</div>
            <a-button @click="editComment" type="link">
              {{ $t('user.Edit') }}
            </a-button>
          </div>
        </template>
        <svg-icon icon-class="search-view"></svg-icon>
        <a-button type="link">{{ $t('user.View Comments') }}</a-button>
      </a-popover>
      <div v-else @click="editComment">
        <FormOutlined />
        <a-button type="link">{{ $t('user.Leave Comments') }}</a-button>
      </div>
    </template>
    <a-modal
      v-model:visible="commentVisible"
      :title="$t('user.Leave Comments')"
      :okText="$t('user.Done')"
      :cancelText="$t('user.Cancel')"
      @ok="submitComment"
      :okButtonProps="{ disabled }"
    >
      <div class="comment-panel">
        <a-textarea
          v-model:value="commentDialogValue"
          :placeholder="$t('user.Please write your comments')"
          :rows="5"
          :maxlength="400"
          :disabled="disabled"
        />
      </div>
    </a-modal>
  </div>
</template>
<script>
  import 'remixicon/fonts/remixicon.css'
  import {
    CheckOutlined,
    CloseOutlined,
    FormOutlined,
  } from '@ant-design/icons-vue'
  export default {
    name: 'CommentsEditor',
    components: { CloseOutlined, FormOutlined },
    props: {
      status: {
        type: String,
        default: 'view',
      },
      text: {
        default: '',
        required: true,
      },
      disabled: {
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        commentDialogValue: this.text,
        commentVisible: false,
        commentsViewPopoverVisible: false,
      }
    },
    computed: {},
    mounted() {
      // console.log(this.value, this.status)
    },
    watch: {},
    methods: {
      editComment() {
        this.commentDialogValue = this.text
        this.commentVisible = true
      },
      submitComment() {
        this.$emit('update:text', this.commentDialogValue)
        this.$emit('autoSave')
        this.commentVisible = false
      },
    },
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');
  .comments-editor {
    color: @primary-color;
    .ant-btn {
      padding: 0 4px;
    }
  }

  .comments-view-text {
    width: 100%;
    word-break: break-word;
  }

  .comments-view-popover {
    width: 280px;
    .btn-popover-close {
      float: right;
    }
    .ant-btn {
      padding: 0;
    }
    .comments-text {
      width: 100%;
      padding-top: 12px;
      word-break: break-word;
    }
  }
</style>
